<template>    
    <section class="breadcrumbs-custom">
    <!-- <div class="parallax-container">
        <div class="material-parallax parallax"><img src="/assets/images/breadcrumbs-bg.jpg" alt="breadcrumbs"></div>
        <div class="breadcrumbs-custom-body parallax-content context-dark">
        <div class="container">
            <h2 class="breadcrumbs-custom-title">Our Menu</h2>
        </div>
        </div>
    </div> -->
    <div class="breadcrumbs-custom-footer">
        <div class="container">
        <ul class="breadcrumbs-custom-path">
            <li><router-link to="/">Home</router-link></li>            
            <li class="active">Our Menu</li>
        </ul>
        </div>
    </div>
    </section>
    <!-- Section Shop-->
    <section class="section pt-50 bg-default text-md-start">
    <div class="container">
        <div class="row row-50">
        <div class="col-lg-4 col-xl-3">
            <filter-component />
        </div>
        <div class="col-lg-8 col-xl-9">
            <div class="product-top-panel group-md">
                <p class="product-top-panel-title">Showing {{ start }}–{{ end }} of {{ pagination.rowsNumber }} results</p>
                <div>
                    <div class="group-sm group-middle">
                        <div class="product-top-panel-sorting">
                            <select v-model="sortBy" ref="selectRef" data-minimum-results-for-search="Infinity">
                            <option value="1">Sort by newness</option>
                            <option value="2">Sort by low price</option>
                            <option value="3">Sort by name</option>
                            </select>
                        </div>                
                    </div>
                </div>
            </div>
            <template v-if="!loading">
                <div class="row row-30 row-lg-50">
                    <template v-if="products.length > 0">
                        <div v-for="product in products" :key="product.id" class="col-12">
                            <!-- Product-->
                            <article class="product-modern text-center text-sm-start">
                                <div class="unit unit-spacing-0 flex-column flex-sm-row">
                                    <div class="unit-left">
                                        <router-link class="product-modern-figure" :to="`${product.category_slug}/${product.slug}`">                                        
                                            <img :src="product.image_328x301 || '/assets/images/dummy_328_330.webp'" :alt="product.name" width="328" height="330" onerror="this.onerror=null;this.src='/assets/images/dummy_328_330.webp';" />
                                        </router-link>
                                    </div>
                                    <div class="unit-body">
                                        <div class="product-modern-body">
                                        <h4 class="product-modern-title"><router-link :to="`${product.category_slug}/${product.slug}`">{{ product.name }}</router-link></h4>
                                        <div class="product-price-wrap">
                                            <!-- <div class="product-price product-price-old">$30.00</div> -->
                                            <div class="product-price">${{ selectedSkus[product.id]?.price || product.base_price }}</div>
                                        </div>
                                        <div class="mt-2">
                                            <div
                                            v-for="sku in product.skus"
                                            :key="`${product.id}-${sku.id}`"
                                            class="mb-2 d-inline-block me-2"
                                            >
                                            <button
                                                type="button"
                                                class="btn btn-sm sku-btn"
                                                :class="
                                                selectedSkus[product.id]?.id === sku.id
                                                    ? 'sku-btn-primary text-white'
                                                    : 'sku-btn-primary-outline'
                                                "
                                                @click="selectSku(product.id, sku)"
                                            >
                                                {{ sku.attributes.map((a) => a.attribute_value).join(' / ') }}
                                            </button>
                                            </div>
                                        </div>
                                        <router-link :to="`${product.category_slug}/${product.slug}`" class="button button-primary button-zakaria">Add to cart</router-link>
                                        </div>
                                    </div>
                                </div>
                                <span class="product-badge product-badge-sale">{{ product.category_name }}</span>
                            </article>
                        </div>            
                    </template>
                    <template v-else>
                        <div class="d-flex justify-content-center">
                            <NoProductFound />
                        </div>
                    </template>
                </div>
                <div class="pagination-wrap">
                    <!-- Bootstrap Pagination-->
                    <nav aria-label="Page navigation">
                        <ul class="pagination">
                            <li 
                            class="page-item" 
                            :class="{ disabled: store.pagination.page === 1 }"
                            @click="store.setPage(store.pagination.page - 1)"
                            >
                            <a class="page-link" href="#">Previous</a>
                            </li>

                            <li 
                            v-for="page in totalPages" 
                            :key="page"
                            :class="['page-item', { active: store.pagination.page === page }]"
                            @click="store.setPage(page)"
                            >
                            <a v-if="products.length > 0" class="page-link" href="#">{{ page }}</a>
                            </li>

                            <li 
                            class="page-item"
                            :class="{ disabled: store.pagination.page === totalPages }"
                            @click="store.setPage(store.pagination.page + 1)"
                            >
                            <a class="page-link" href="#">Next</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </template>
            <template v-else>
                <div class="text-center py-5">
                    <div class="lds-dual-ring"></div>
                    <h6 class="mt-3 text-muted">Loading products...</h6>
                </div>
            </template>
        </div>
        </div>
    </div>
    </section>
</template>
<script setup>
import { onMounted, computed, ref, watch, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import FilterComponent from "@/components/FilterComponent.vue";
import { useProductStore } from "@/stores/productStore";
import { storeToRefs } from "pinia";
import { useCommonStore } from "@/stores/commonStore";
import NoProductFound from "@/components/common/NoProductFound.vue";
import { useCartStore } from "@/stores/cart";

const commonStore = useCommonStore();
const store = useProductStore();
const route = useRoute();
const { products, pagination, loading } = storeToRefs(store);

const cartStore = useCartStore()

const selectRef = ref(null)
const sortBy = ref(1)
const selectedSkus = ref({})

watch(sortBy, (v) => {
  window.$(selectRef.value).val(v).trigger('change.select2')
  onSortChange(v)
})

function onSortChange(value) {    
  if (value == '1') {
    store.setSort("created_at", true)
  } else if (value == '2') {
    store.setSort("base_price", false)
  } else if (value == '3') {
    store.setSort("name", false)
  }
}

const totalPages = computed(() => {
  const total = Math.ceil(
    (store.pagination.rowsNumber || 0) / store.pagination.rowsPerPage
  )
  return total > 0 ? total : 1
})

const start = computed(() => (pagination.value.page - 1) * pagination.value.rowsPerPage + 1)
const end = computed(() => Math.min(pagination.value.page * pagination.value.rowsPerPage, pagination.value.rowsNumber))

// Change SKU when user clicks attribute
function selectSku(productId, sku) {
  selectedSkus.value[productId] = sku
}

function addProductToCart(product) {  
  let sku_varient = selectedSkus.value[product.id].attributes.map((a) => a.attribute_value).join(' / ')

  let cartItem = {
    product_id: product.id,
    product_sku_id: selectedSkus.value[product.id].id,
    name: `${product.name} - ${sku_varient}`,
    price: selectedSkus.value[product.id].price,
    image: product.image_187x155
  }
  cartStore.addToCart(cartItem)
}

onMounted(async () => {
    commonStore.loaderVisible = true;   
    cartStore.loadCart()
    await commonStore.getCategories();
    await commonStore.getAttributes();
    
    if (route.query.category) {
        const catMap = {
            'exotic-cakes': 5,
            'standard-cakes': 6,
            'premium-cakes': 4
        };
        const catId = catMap[route.query.category];
        if (catId && !store.filters.category_id.includes(catId)) {
            store.filters.category_id.push(catId);
        }
    }

    await store.fetchProducts();   

    products.value.forEach((product) => {
        selectedSkus.value[product.id] = product.skus[0] // default first SKU
    })

    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
        // Replace it: remove and re-add
        existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)      


    // initialize select2
    window.$(selectRef.value).select2({
        minimumResultsForSearch: Infinity
    })

    // set default value
    window.$(selectRef.value).val(sortBy.value).trigger('change.select2')

    // Vue <- Select2 (user changed dropdown)
    window.$(selectRef.value).on('change', (e) => {
        sortBy.value = e.target.value
    })

    commonStore.loaderVisible = false;
})

onUnmounted(() => {
    store.resetFilters()
})
</script>
